import React from 'react'
import TaskOptions from '../common_components/TaskOptions'
import CustomItemModalBox from '../common_components/CustomItemModalBox'

class ScheduleCategoryItem extends React.Component {

  handleCheck () {
    $.post('/timeline_items/save_checkbox', { timeline_id: this.props.timelineItem.timeline_id, checked: !this.props.timelineItem.check_status }, (data) => {
      this.props.onTimelineCheck(data)
    })
  }

  handleItemClick () {
    if (this.props.timelineItem.just_looking) {
      this.props.handleJustLookingClick(true)
    } else {
      $.getJSON(`/timeline_items/${this.props.timelineItem.timeline_id}/fetch_details`, {fetch_link: true}, (data) => {
        const task = this.props.timelineItem
        let taskId = task.leave_item_id
        let lookUpField = 'leave_item_id'
        if (task.custom_task) {
          taskId = task.timeline_id
          lookUpField = 'timeline_id'
        }
        gon.company_variables = {...gon.company_variables, ...data.statutory_substitutions_options}
        this.props.handleItemClick('timeline_event', taskId, data.description, data.image_url, data.association, lookUpField, data.item_files)
      })
    }
  }

  handleCustomTaskClick () {
    this.props.handleCustomTaskClick(this.props.timelineItem.id)
  }

  handleCustomTaskClose () {
    this.props.handleCustomTaskClick('')
  }

  renderCustomItemModalBox () {
    if (this.props.custom_task_modal === this.props.timelineItem.id) {
      return (
        <CustomItemModalBox
          item={this.props.timelineItem}
          editMode={true}
          handleCustomTaskChange={this.props.handleCustomTaskChange}
          handleCustomTaskClose={this.handleCustomTaskClose.bind(this)}
          disabledTaskEmailNotifications={this.props.disabledTaskEmailNotifications}
        />
      )
    }
  }

  renderDate() {
    if(this.props.categoryClassName != 'ready_to_complete') {
      return (
        <span> { moment(this.props.timelineItem.date).format('MM/DD/YYYY') } </span>
      )
    }
  }

  render () {
    return (
      <div>
        <div className='category-item'>
          <div>
            <div className='rounded-checkbox'>
              <input type='checkbox' className='timeline-check' checked={this.props.timelineItem.check_status} />
                <label onClick={() => this.handleCheck()}>
              </label>
            </div>
            <span
              className={`timeline-name ${this.props.categoryClassName}`}
              onClick={this.handleItemClick.bind(this)}
            >
              { this.props.timelineItem.name }
            </span>
          </div>
          <div className='task-options'>
            <span className='task-event-type'> { this.props.timelineItem.event_type } </span>
            { this.renderDate() }
            <TaskOptions
              data={this.props.timelineItem}
              onHelpfulCheck={this.props.onHelpfulCheck}
              handleCustomTaskDelete={this.props.handleCustomTaskDelete}
              handleCustomTaskClick={this.handleCustomTaskClick.bind(this)}
              isLeavePlanPartner={this.props.isLeavePlanPartner}
              disabledTaskEmailNotifications={this.props.disabledTaskEmailNotifications}
            />
          </div>
        </div>
        <hr className='timeline-item-hr' />
        { this.renderCustomItemModalBox() }
      </div>
    )
  }
}

export default ScheduleCategoryItem;
